/** Prompt "chiamata in arrivo" per il supervisore. Montato globalmente in MainLayout. */
import { PhoneIncoming } from "lucide-react";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useSupport } from "./SupportContext";

export function IncomingCallModal() {
  const { incoming, accept, decline, richiestaInCorso } = useSupport();
  const navigate = useNavigate();
  const location = useLocation();
  const acceptRef = useRef<HTMLButtonElement>(null);

  // Focus sul bottone principale all'apertura, per chi naviga da tastiera/screen reader.
  useEffect(() => {
    if (incoming) acceptRef.current?.focus();
  }, [incoming]);

  if (!incoming) return null;

  const onAccept = async () => {
    await accept();
    if (location.pathname !== "/supporto") navigate("/supporto");
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="incoming-call-title"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
    >
      <div className="w-full max-w-md rounded-xl bg-surface p-6 shadow-xl">
        <div className="flex items-center gap-3">
          <PhoneIncoming className="h-6 w-6 text-brand" aria-hidden="true" />
          <h2 id="incoming-call-title" className="text-lg font-semibold">
            Richiesta di aiuto
          </h2>
        </div>
        <p className="mt-3 text-sm">
          <strong>{incoming.affiliatoNome}</strong> ti chiede aiuto.
        </p>
        {incoming.contesto && (
          <p className="mt-1 text-sm text-muted-foreground">Contesto: {incoming.contesto}</p>
        )}
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={decline}
            className="rounded-lg bg-surface px-4 py-2 text-sm ring-1 ring-black/10 transition-colors hover:bg-border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
          >
            Rifiuta
          </button>
          <button
            ref={acceptRef}
            type="button"
            // `accept` attende getUserMedia (1-3s) e la modale resta montata fino a
            // quando riesce: senza questo il bottone accetta un secondo click che il
            // guard di idempotenza scarta, senza alcun riscontro per chi lo preme.
            disabled={richiestaInCorso}
            onClick={() => void onAccept()}
            className="rounded-lg bg-brand px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-brand"
          >
            Accetta
          </button>
        </div>
      </div>
    </div>
  );
}
